import axios from 'axios';
import { API_URL } from '../config/axiosConfig';
import {
  apiCreateSahakari,
  apiGetSahakari,
  apiGetSahakariById,
  apiDeleteSahakariById,
  apiUpdateSahakari,
  apiGetSahakariMainBranch,
  apiAddSahakariCustomersCsv,
  apiGetSahakariStats,
  apiGetSahakariSubscriptionStatus,
} from './sahakariApi';
import {
  apiCreateCollector,
  apiGetCollector,
  apiGetCollectorById,
  apiUpdateCollector,
  apiTransferCollectorCustomers,
  apiGetActiveCollector,
} from './collectorApi';
import {
  apiCreateCustomer,
  apiGetCustomer,
  apiGetCustomerById,
  apiUpdateCustomer,
  apiAssignCollector,
  apiGetLast5TransactionCustomer,
  apiGetAllTransactionCustomerById,
  apiGetUnassignedCustomer,
  apiGetCustomerTableListing,
} from './customerApi';

import {
  apiGetBatchByDate,
  apiGetTransactionsByBatch,
  apiVerifyBatch,
  apiGetBatchToday,
} from './batchApi';

import {
  apiGetPendingWithdrawlRequest,
  apiApproveWithdrawlRequest,
  apiGetPendingBatchRequest,
} from './notificationApi';

import {
  apiGetTransactionByDate,
  apiGetTransactionToday,
} from './transactionApi';

export const apiSigninUser = (data) => axios.post(`${API_URL}/login`, data);

export const apiGetUser = (token) =>
  axios.post(
    `${API_URL}/v1/users/token/refresh`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

//sahakari apis (SUPERADMIN)
export {
  apiCreateSahakari,
  apiGetSahakari,
  apiGetSahakariById,
  apiDeleteSahakariById,
  apiUpdateSahakari,
  apiGetSahakariMainBranch,
  apiAddSahakariCustomersCsv,
};

//collector apis (SAHAKARI_ADMIN)
export {
  apiCreateCollector,
  apiGetCollector,
  apiGetCollectorById,
  apiUpdateCollector,
  apiTransferCollectorCustomers,
  apiGetActiveCollector,
  apiGetSahakariStats,
  apiGetSahakariSubscriptionStatus,
};

export {
  apiCreateCustomer,
  apiGetCustomer,
  apiGetCustomerTableListing,
  apiGetCustomerById,
  apiUpdateCustomer,
  apiAssignCollector,
  apiGetLast5TransactionCustomer,
  apiGetAllTransactionCustomerById,
  apiGetUnassignedCustomer,
};

export {
  apiGetBatchByDate,
  apiGetTransactionsByBatch,
  apiVerifyBatch,
  apiGetBatchToday,
};

export {
  apiGetPendingWithdrawlRequest,
  apiApproveWithdrawlRequest,
  apiGetPendingBatchRequest,
};

export { apiGetTransactionByDate, apiGetTransactionToday };
